module.exports = __webpack_public_path__ + "img/chart-running-run-steps-new.cb53b7f8.png";